module.exports = __webpack_public_path__ + "img/Scratched Table.e4502ec2.png";